module.exports = __webpack_public_path__ + "img/logo-header-white.cf0e00cc.png";